import { Component, OnInit, ViewEncapsulation, Inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormArray } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { fuseAnimations } from '@fuse/animations';
import { DropdownsService } from 'app/services';
import { map} from 'lodash';
import { TranslateService } from '@ngx-translate/core';
@Component({
    selector: 'app-custom-fields',
    templateUrl: './custom-fields.component.html',
    styleUrls: ['./custom-fields.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})

export class CustomFieldsComponent implements OnInit {

    customFields: UntypedFormGroup;
    formFields: UntypedFormArray;
    systemlang: any;
    initialValue: any;
    currentLang: any;
    propertyCategories = [];
    custom_categories: any;
    agency_custom_categories: any;
    custom_cat_label: string ;
    show_custom_cat: boolean = false;

    constructor(
        public matDialogRef: MatDialogRef<CustomFieldsComponent>,
        @Inject(MAT_DIALOG_DATA) public _data: any,
        private formBuilder: UntypedFormBuilder,
        private _dropdownsService: DropdownsService,
        public _translateService: TranslateService,
    ) {
        this.currentLang = this._translateService.currentLang;
    }

    ngOnInit(): void {
        this.customFields = this.formBuilder.group({
            fields: this.formBuilder.array([this.addCustomFields()]),
            custom_categories: { value: this._data.custom_categories, disabled: true },
            agency_custom_categories: { value: this._data.agency_custom_categories, disabled: false },
        })
        this.formFields = this.customFields.get('fields') as UntypedFormArray;
        if(this._data?.custom_fields.length){
            this.initializeCustomFields(this._data?.custom_fields);
        }

        this._dropdownsService.getPropertyCategory()
            .subscribe((data: any) => {
                data.body = map(data.body, (mooring) => {
                    mooring.label = mooring.value[this.currentLang];
                    return mooring;
                });
                this.propertyCategories = data.body;
            });

        this.customCatLabel(this.show_custom_cat);
    }

    addCustomFields(field?: any): UntypedFormGroup {
        return this.formBuilder.group({
            key: field?.key ? field.key : [],
            value: field?.value ? field.value : [],
        });
    }

    initializeCustomFields(fields: any) {
        this.formFields.removeAt(0)
        fields.forEach(field => {
          this.formFields.push(this.addCustomFields(field));
        });
    }
    
    customCatLabel(visibility: boolean){
        this.show_custom_cat = visibility;
        if(visibility){
            this.custom_cat_label = "Hide custom categories";
        }else{
            this.custom_cat_label = "Show custom categories";
        }
    }

}
